import { createRoutine } from 'redux-saga-routines';

export const fetchCrmObjectProperties = createRoutine(
  'FETCH_CRM_OBJ_PROPERTIES'
);
export const fetchCriterias = createRoutine('FETCH_CRM_CRITERIAS');
export const fetchCrmDataMappings = createRoutine('FETCH_CRM_DATA_MAPPINGS');
export const fetchCrmDeduplicationMappings = createRoutine(
  'FETCH_CRM_DEDUPLICATION_MAPPINGS'
);
export const fetchCrmInSyncFilters = createRoutine('FETCH_CRM_IN_SYNC_FILTERS');
export const fetchCrmInSyncDataMappings = createRoutine(
  'FETCH_CRM_IN_SYNC_DATA_MAPPINGS'
);

export const createCondition = createRoutine('CREATE_CRM_CONDTION');
export const createDataMapping = createRoutine('CREATE_CRM_DATA_MAPPING');
export const createDeduplicationMapping = createRoutine(
  'CREATE_CRM_DEDUPLICATION_MAPPING'
);
export const createInSyncFilter = createRoutine('CREATE_CRM_IN_SYNC_FILTER');

export const changeCrmConfigTab = createRoutine('CHANGE_CRM_CONFIG_TAB');
export const changeCrmFieldMapping = createRoutine('CHANGE_CRM_FIELD_MAPPING');
export const changeDeduplication = createRoutine('CHANGE_CRM_DEDUPLICATION');
export const changeCrmPipeline = createRoutine('CHANGE_CRM_PIPELINE');
export const changeCrmStage = createRoutine('CHANGE_CRM_STAGE');
export const changeCrmDataMapping = createRoutine('CHANGE_CRM_DATA_MAPPING');
export const changeCrmDataMappingFieldConfig = createRoutine(
  'CHANGE_CRM_DATA_MAPPING_FIELD_CONFIG'
);
export const changeConditionProperty = createRoutine(
  'CHANGE_CRM_CONDITION_PROPERTY'
);
export const changeCrmObjectType = createRoutine('CHANGE_CRM_OBJECT_TYPE');
export const changeCrmInSyncFilter = createRoutine('CHANGE_CRM_IN_SYNC_FILTER');

export const addCondition = createRoutine('ADD_CRM_CONDITION');
export const addDataMapRow = createRoutine('ADD_CRM_DATA_MAP_ROW');
export const addConditionProperty = createRoutine('ADD_CRM_CONDITION_PROPERTY');
export const addInSyncFilter = createRoutine('ADD_CRM_IN_SYNC_FILTER');

export const clearUnsavedChanges = createRoutine('CLEAR_UNSAVED_CHANGES');

export const removeConditionProperty = createRoutine(
  'DEL_CRM_CONDITION_PROPERTY'
);
export const removeCondition = createRoutine('DEL_CRM_CONDITION');
export const removeCrmStage = createRoutine('DEL_CRM_STAGE');
export const removeDataMapRow = createRoutine('DEL_CRM_DATA_MAP_ROW');
export const removeInSyncFilterRow = createRoutine(
  'DEL_CRM_IN_SYNC_FILTER_ROW'
);

export const clearCrmStage = createRoutine('CLEAR_CRM_STAGE');

export const cancelDeduplicationMapping = createRoutine(
  'CANCEL_DEDUPLICATION_MAPPING'
);
export const cancelDataMapping = createRoutine('CANCEL_DATA_MAPPING');
export const cancelCondition = createRoutine('CANCEL_CONDITION');
export const cancelObjectType = createRoutine('CANCEL_OBJECT_TYPE');
export const cancelInSyncFilter = createRoutine('CANCEL_IN_SYNC_FILTER');
export const changeNoteSyncStatus = createRoutine('CHANGE_NOTE_SYNC_STATUS');
export const saveNoteSyncStatus = createRoutine('SAVE_NOTE_SYNC_STATUS');
export const cancelNoteSyncStatus = createRoutine('CANCEL_NOTE_SYNC_STATUS');
export const fetchNoteSyncStatus = createRoutine('FETCH_NOTE_SYNC_STATUS');
export const showUnSavedModal = createRoutine('SHOW_UNSAVED_MODAL');
export const changeHeaderButton = createRoutine('CHANGE_HEADER_BUTTON');
export const changeSideListItem = createRoutine('CHANGE_SIDE_LIST_ITEM');
export const saveCrmConfigStatus = createRoutine('SAVE_CRM_CONFIG_STATUS');
export const fetchCrmConfigStatus = createRoutine('FETCH_CRM_CONFIG_STATUS');
export const changeNoteEntityTab = createRoutine('CHANGE_NOTE_ENTITY_TAB');
export const getNoteSyncEditStatus = createRoutine('GET_NOTE_SYNC_EDIT_STATUS');
// Parent Link Routines
export const changeParentLinkMapping = createRoutine(
  'CHANGE_PARENT_LINK_MAPPING'
);
export const cancelParentLinkMapping = createRoutine(
  'CANCEL_PARENT_LINK_MAPPING'
);
export const changeParentLinkStatus = createRoutine(
  'CHANGE_PARENT_LINK_STATUS'
);
export const cancelParentLinkStatus = createRoutine(
  'CANCEL_PARENT_LINK_STATUS'
);
export const fetchParentLinkConfigStatus = createRoutine(
  'FETCH_PARENT_LINK_CONFIG_STATUS'
);
export const saveParentLinkConfigStatus = createRoutine(
  'SAVE_PARENT_LINK_CONFIG_STATUS'
);

export const clearCrmActivityTypeMapping = createRoutine(
  'CLEAR_CRM_ACTIVITY_TYPE_MAPPING'
);
export const changeCrmActivityTypeMapping = createRoutine(
  'CHANGE_CRM_ACTIVITY_TYPE_MAPPING'
);
export const removeCrmActivityTypeMapping = createRoutine(
  'REMOVE_CRM_ACTIVITY_TYPE_MAPPING'
);
export const setCrmActivityTypes = createRoutine(
  'SET_CRM_AVAILABLE_ACTIVITY_TYPES'
);
export const fetchCrmActivityConfigs = createRoutine(
  'FETCH_CRM_ACTIVITY_CONFIGS'
);
export const changeCrmActivitySyncStatus = createRoutine(
  'CHANGE_CRM_ACTIVITY_SYNC_STATUS'
);
export const changeCrmActivitySyncConfiguration = createRoutine(
  'CHANGE_CRM_ACTIVITY_SYNC_CONFIGURATION'
);
export const fetchCrmActivityMapping = createRoutine(
  'FETCH_CRM_ACTIVITY_MAPPING'
);
export const saveCrmActivitySyncConfig = createRoutine(
  'SAVE_CRM_ACTIVITY_SYNC_CONFIG'
);
export const changeActivitySyncEditStatus = createRoutine(
  'CHANGE_ACTIVITY_SYNC_EDIT_STATUS'
);
export const clearActivitySyncConfig = createRoutine(
  'CLEAR_ACTIVITY_SYNC_CONFIG'
);
export const changeParentCreateStatus = createRoutine(
  'CHANGE_PARENT_CREATE_STATUS'
);
export const cancelParentCreateStatus = createRoutine(
  'CANCEL_PARENT_CREATE_STATUS'
);

export const saveParentCreateStatus = createRoutine(
  'SAVE_PARENT_CREATE_STATUS'
);

export const fetchParentCreateStatus = createRoutine(
  'FETCH_PARENT_CREATE_STATUS'
);

export const changeDeduplicationUpdateStatus = createRoutine(
  'CHANGE_DEDUPLICATION_UPDATE_STATUS'
);
export const cancelDeduplicationUpdateStatus = createRoutine(
  'CANCEL_DEDUPLICATION_UPDATE_STATUS'
);

export const saveDeduplicationUpdateStatus = createRoutine(
  'SAVE_DEDUPLICATION_UPDATE_STATUS'
);

export const fetchDeduplicationUpdateStatus = createRoutine(
  'FETCH_DEDUPLICATION_UPDATE_STATUS'
);

export const changeAdditionalDeduplicationStatus = createRoutine(
  'CHANGE_ADDITIONAL_DEDUPLICATION_STATUS'
);
export const cancelAdditionalDeduplicationStatus = createRoutine(
  'CANCEL_ADDITIONAL_DEDUPLICATION_STATUS'
);
export const saveAdditionalDeduplicationStatus = createRoutine(
  'SAVE_ADDITIONAL_DEDUPLICATION_STATUS'
);
export const fetchAdditionalDeduplicationStatus = createRoutine(
  'FETCH_ADDITIONAL_DEDUPLICATION_STATUS'
);

export const changeAdditionalDeduplicationMapping = createRoutine(
  'CHANGE_ADDITIONAL_DEDUPLICATION_MAPPING'
);
export const cancelAdditionalDeduplicationMapping = createRoutine(
  'CANCEL_ADDITIONAL_DEDUPLICATION_MAPPING'
);

export const createAdditionalDeduplicationMapping = createRoutine(
  'CREATE_ADDITIONAL_DEDUPLICATION_MAPPING'
);

export const fetchAdditionalDeduplicationMapping = createRoutine(
  'FETCH_ADDITIONAL_DEDUPLICATION_MAPPING'
);

// sync data routines
export const fetchSyncDataStatus = createRoutine('FETCH_SYNC_DATA_STATUS');
export const triggerSyncDataStatus = createRoutine('TRIGGER_SYNC_DATA_STATUS');
